import ADMIN_PERMISSIONS from '@/constants/authorization/admin-permissions'

export default [
  {
    header: 'navigation.analysis',
  },
  {
    title: 'navigation.statistics',
    route: 'super:statistics',
    adminPermissions: [ADMIN_PERMISSIONS.STATISTICS],
    icon: 'BarChartIcon',
  },
  {
    title: 'navigation.reports',
    route: 'super:reports',
    adminPermissions: [ADMIN_PERMISSIONS.RECEIVE_REGULAR_REPORT],
    icon: 'FileTextIcon',
  },
  {
    title: 'Selling types report',
    route: 'super:selling-types-report',
    adminPermissions: [ADMIN_PERMISSIONS.RECEIVE_REGULAR_REPORT],
    icon: 'DownloadIcon',
  },
  {
    title: 'feature-statistics.title',
    route: 'super:feature-statistics',
    adminPermissions: [ADMIN_PERMISSIONS.ACCOUNTS],
    icon: 'AlertTriangleIcon',
  },
]
